import React from 'react';

function Experience({ experience }) {
  return (
    <section className="portfolioSection sectionReveal" id="experience">
      <div className="portfolioSection__heading">
        <span className="portfolioEyebrow">Experience</span>
        <h2>Where I've worked</h2>
      </div>

      <div className="portfolioExperience">
        {experience.map((item) => (
          <article className="portfolioExperience__card" key={`${item.company}-${item.role}`}>
            <div className="portfolioExperience__logo" aria-hidden="true">{item.logo}</div>
            <div className="portfolioExperience__body">
              <div className="portfolioExperience__meta">
                <div>
                  <h3>{item.company}</h3>
                  <p>{item.role}</p>
                </div>
                <span>{item.duration}</span>
              </div>
              <p>{item.impact}</p>
              <div className="portfolioTags">
                {item.technologies.map((tech) => <span key={tech}>{tech}</span>)}
              </div>
              <ul className="portfolioList">
                {item.achievements.map((achievement) => <li key={achievement}>{achievement}</li>)}
              </ul>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Experience;
